export enum PortalTrackingEvents {
  /* login */
  portalSignInPressed = 'portal_sign_in_pressed',
  portalSignInFromSelectOptionPressed = 'portal_sign_in_from_select_option_pressed',
  portalSignInFromSelectOptionContinuePressed = 'portal_sign_in_from_select_option_continue_pressed',
  portalContinueAsGuestPressed = 'portal_continue_as_guest_pressed',
  portalContinueWithGooglePressed = 'portal_continue_with_google_pressed',
  portalContinueWithFacebookPressed = 'portal_continue_with_facebook_pressed',
  portalContinueWithEmailPressed = 'portal_continue_with_email_pressed',
  portalActivationCodeEntered = 'portal_activation_code_entered',
  portalLogoutPressed = 'portal_logout_pressed',
  portalContinueWithEmailInputFocused = 'portal_continue_with_email_input_focused',
  portalContinueWithEmailInputSubmitted = 'portal_continue_with_email_input_submitted',

  /* quote */
  quoteOpened = 'quote_opened',
  quoteClosed = 'quote_closed',
  quoteOverviewSeen = 'quote_overview_seen',
  portalQuotePasscodeScreenShown = 'portal_quote_passcode_screen_shown',
  portalQuotePasscodeAgentSuccess = 'portal_quote_passcode_agent_success',
  portalQuotePasscodeClientSuccess = 'portal_quote_passcode_client_success',
  portalQuotePasscodeInvalidCode = 'portal_quote_passcode_invalid_code',

  /* portal auto quote */
  portalAutoQuotePageOpened = 'portal_auto_quote_page_opened',
  portalAutoQuoteExpiredPageOpened = 'portal_auto_quote_expired_page_opened',
  portalAutoQuoteExpiredCallExpertPressed = 'portal_auto_quote_expired_call_expert_pressed',
  portalAutoQuoteThankYouPageOpened = 'portal_auto_quote_thank_you_page_opened',
  portalAutoQuoteShareWithExpertPressed = 'portal_auto_quote_share_with_expert_pressed',
  portalAutoQuoteOptionLikePressed = 'portal_auto_quote_option_like_pressed',
  portalAutoQuoteOptionDislikePressed = 'portal_auto_quote_option_dislike_pressed',

  /* passenger form */
  firstName = 'portal_checkout_pax_{index}_first_name',
  middleName = 'portal_checkout_pax_{index}_middle_name',
  lastName = 'portal_checkout_pax_{index}_last_name',
  gender = 'portal_checkout_pax_{index}_gender_{value}',
  birthday = 'portal_checkout_pax_{index}_birthday',
  passportCountryId = 'portal_checkout_pax_{index}_country',
  portalCheckoutPaxBirthdayError = 'portal_checkout_pax_{index}_birthday_error',
  portalCheckoutSubmitOptionError = 'portal_checkout_submit_option_error',
  portalCheckoutSubmitPassengersError = 'portal_checkout_submit_passengers_error',
  portalCheckoutSubmitPassengersFieldsRequiredError = 'portal_checkout_submit_passengers_fields_required_error',

  /* passenger page */
  portalCheckoutPassengersOpened = 'portal_checkout_passengers_opened',
  portalCheckoutPassengersBackPressed = 'portal_checkout_passengers_back_pressed',
  submitPassengers = 'submit_passengers',

  /* disruption protection page */
  portalDisruptionProtectionContinuePressed = 'portal_disruption_protection_continue_pressed',
  portalDisruptionProtectionNoThanksPressed = 'portal_disruption_protection_no_thanks_pressed',
  portalDisruptionProtectionBackPressed = 'portal_disruption_protection_back_pressed',
  portalDisruptionProtectionOpened = 'portal_disruption_protection_opened',

  /* cancel for any reason page */
  portalCancelForAnyReasonContinuePressed = 'portal_cancel_for_any_reason_continue_pressed',
  portalCancelForAnyReasonNoThanksPressed = 'portal_cancel_for_any_reason_no_thanks_pressed',
  portalCancelForAnyReasonBackPressed = 'portal_cancel_for_any_reason_back_pressed',
  portalCancelForAnyReasonOpened = 'portal_cancel_for_any_reason_opened',
  portalUpsellDisruptionProtectionModalContinuePressed = 'portal_upsell_disruption_protection_modal_continue_pressed',
  portalUpsellDisruptionProtectionModalNoThanksPressed = 'portal_upsell_disruption_protection_modal_no_thanks_pressed',
  portalUpsellBundleModalContinuePressed = 'portal_upsell_bundle_modal_continue_pressed',
  portalUpsellBundleModalNoThanksPressed = 'portal_upsell_bundle_modal_no_thanks_pressed',

  /* ancillary bundle page */
  portalAncillaryBundleContinuePressed = 'portal_ancillary_bundle_continue_pressed',
  portalAncillaryBundleBackPressed = 'portal_ancillary_bundle_back_pressed',
  portalAncillaryBundleAncillaryPressed = 'portal_ancillary_bundle_{ancillary}_pressed',
  portalAncillaryBundleOpened = 'portal_ancillary_bundle_opened',

  /* gratitude page */
  portalCheckoutGratitudeOpened = 'portal_checkout_gratitude_opened',
  portalCheckoutGratitudeEntered = 'portal_checkout_gratitude_entered',
  portalCheckoutGratitudeBackPressed = 'portal_checkout_gratitude_back_pressed',
  portalCheckoutGratitudeContinuePressed = 'portal_checkout_gratitude_continue_pressed',

  /* card form */
  number = 'portal_checkout_payment_card_number',
  holder = 'portal_checkout_payment_card_holder',
  expiration = 'portal_checkout_payment_expiration',
  cvv2 = 'portal_checkout_payment_cvv',
  countryId = 'portal_checkout_payment_country',
  billingAddress1 = 'portal_checkout_payment_address_line1',
  billingAddress2 = 'portal_checkout_payment_address_line2',
  state = 'portal_checkout_payment_state',
  city = 'portal_checkout_payment_city',
  zipCode = 'portal_checkout_payment_zip',
  portalCheckoutPaymentFieldsRequiredError = 'portal_checkout_payment_fields_required_error',

  /* card page */
  switchOnSplit = 'switch_on_split',
  switchOffSplit = 'switch_off_split',
  submitCard = 'submit_card',
  portalCheckoutPaymentBackPressed = 'portal_checkout_payment_back_pressed',
  portalCheckoutPaymentTermsChecked = 'portal_checkout_payment_terms_checked',

  /* stripe */
  submitStripe = 'submit_stripe',
  portalCheckoutStripePaymentAddress = 'portal_checkout_stripe_payment_address',
  portalCheckoutStripeCardError = 'portal_checkout_stripe_card_error',
  portalCheckoutStripeCardExpiryErrors = 'portal_checkout_stripe_card_expiry_error',
  portalCheckoutStripeCardNumberErrors = 'portal_checkout_stripe_card_number_error',
  portalCheckoutStripeCardCvcErrors = 'portal_checkout_stripe_card_cvc_error',

  /* thank you page */
  portalCheckoutSuccess = 'portal_checkout_success',
  portalCheckoutContinueWithEmailInputFocused = 'portal_checkout_continue_with_email_input_focused',
  portalCheckoutContinueWithEmailInputSubmitted = 'portal_checkout_continue_with_email_input_submitted',
  portalCheckoutContinueWithGooglePressed = 'portal_checkout_continue_with_google_pressed',

  /* additional old events */
  leadWithAgentOpened = 'lead_with_agent_opened',
  portalOptionSelected = 'portal_option_selected',
  portalCheckoutPaymentOpened = 'portal_checkout_payment_opened',

  /* overview and payment events */
  portalOverviewAndPaymentError = 'portal_overview_and_payment_error',
  portalOverviewAndPaymentPromocodeError = 'portal_overview_and_payment_promocode_error',
  portalOverviewAndPaymentFormError = 'portal_overview_and_payment_form_error',
  portalOverviewAndPaymentClientBalanceAmountError = 'portal_overview_and_payment_client_balance_amount_error',
  portalOverviewAndPaymentCombinedDiscountError = 'portal_overview_and_payment_combined_discount_error',
  portalOverviewAndPaymentCreditCardError = 'portal_overview_and_payment_credit_card_error',
  portalOverviewAndPaymentPaxBirthdayError = 'portal_overview_and_payment_pax_{index}_birthday_error',

  /* booking page */
  portalBookingRequestError = 'portal_booking_request_error',

  /* lead page */
  portalLeadRequestError = 'portal_lead_request_error',

  /* trip page */
  portalAuthorizedOrderRequestError = 'portal_authorized_order_request_error',

  /* travelers page */
  travelersPageOpened = 'travelers_page_opened',

  /* traveler page */
  travelerPageOpened = 'traveler_page_opened',
  travelerPageBackPressed = 'traveler_page_back_pressed',
  travelerPageCancelPressed = 'traveler_page_cancel_pressed',
  travelerPageSubmitPressed = 'traveler_page_submit_pressed',
  travelerPageSubmitError = 'traveler_page_submit_error',

  /* ancillary upsell page */
  ancillaryUpsellPageOpened = 'ancillary-upsell-page-opened',

  /* ancillary upsell success page */
  ancillaryUpsellSuccessPageOpened = 'ancillary-upsell-success-page-opened',
  ancillaryUpsellErrorPageOpened = 'ancillary-upsell-error-page-opened',

  /* quick quote */
  quickQuoteShown = 'quick_quote_shown',
  quickQuoteAnswerClicked = 'quick_quote_answer_clicked',
  quickQuoteButtonPressed = 'quick_quote_button_pressed',

  /* referral program */
  portalReferralLinkCopied = 'portal_referral_link_copied',
  portalReferralShareEmailPressed = 'portal_referral_share_email_pressed',
  portalReferralShareSmsPressed = 'portal_referral_share_sms_pressed',
  portalReferralShareWhatsappPressed = 'portal_referral_share_whatsapp_pressed',

  /* tiers page */
  tiersPageOpened = 'tiers_page_opened',
  tiersPageBackPressed = 'tiers_page_back_pressed',
  tiersPageSubmitPressed = 'tiers_page_submit_pressed',
  tiersPageSelectTier = 'tiers_page_select_tier',
  tiersPageUpgradePressed = 'tiers_page_upgrade_pressed',
}

export const getTrackingEvent = (key: string): string | undefined => {
  return PortalTrackingEvents[key as keyof typeof PortalTrackingEvents];
};
